export default __webpack_public_path__ + "static/media/ProductSans-Black.b9f114a6.ttf";